import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import "react-calendar/dist/Calendar.css";
import Moment from "moment";
import { updateAddUserRequest } from "../Services/ReportingService";
import { formatPhoneNumberString, formatBooleanAsString, ConvertEmptyToNA } from "../Util/Utils";
import "../style/DetailsModals.css";
import { NotificationsContext } from "../Contexts/NotificationsContext";

const AddUserRequestDetailsModal = (props) => {
  const [request, setRequest] = useState();
  const [wasRequestUpdated, setWasRequestUpdated] = useState(false);
  const { addNotification } = useContext(NotificationsContext);

  useEffect(() => {
    if (props.show) {
      setRequest(props.request);
    }
  }, [props.request, props.show]);

  const onSave = () => {
    if (wasRequestUpdated) {
      let updatedRequest = request;
      updatedRequest.CompletedDate = new Date();
      updatedRequest.CompletedBy = props.crmUser.UserName;
      props.setRequestIdBeingUpdated(updatedRequest.RequestId);
      updateAddUserRequest(updatedRequest)
        .then(() => {
          props.setUpdatedRequest({
            request: updatedRequest,
            type: "add",
          });
          addNotification({ show: true, type: "Success", description: "User Update Request Updated Successfully" });
          props.onHide();
        })
        .catch(() => {
          addNotification({
            show: true,
            type: "Error",
            description: (
              <>
                Updating Update User Request Failed. We ran into an issue submitting your request. Please contact
                <b> itsupport@gocitywide.com</b> for assistance.
              </>
            ),
          });
          props.setRequestIdBeingUpdated("");
          props.onHide();
        });
    }
    props.onHide();
  };

  const onCheckboxClick = (checkboxClicked) => {
    if (checkboxClicked === "franAccount") {
      setRequest({ ...request, FranchiseAccounting: !request.FranchiseAccounting });
    }
    if (checkboxClicked === "inTwo") {
      setRequest({ ...request, InTwoLogin: !request.InTwoLogin });
    }
    if (checkboxClicked === "bc") {
      setRequest({ ...request, Bc: !request.Bc });
    }
    if (checkboxClicked === "jet") {
      setRequest({ ...request, JetHubCreate: !request.JetHubCreate });
    }
    if (checkboxClicked === "zendesk") {
      setRequest({ ...request, ZendeskSetup: !request.ZendeskSetup });
    }
    if (checkboxClicked === "groupMan") {
      setRequest({ ...request, GroupManagement: !request.GroupManagement });
    }
    if (checkboxClicked === "exchange") {
      setRequest({ ...request, ExchangeLicense: !request.ExchangeLicense });
    }
    if (checkboxClicked === "o365") {
      setRequest({ ...request, O365License: !request.O365License });
    }
    if (checkboxClicked === "distro") {
      setRequest({ ...request, DistroSetup: !request.DistroSetup });
    }

    setWasRequestUpdated(true);
  };

  return (
    <Modal show={props.show} onHide={props.onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        {props.request && (
          <Modal.Title id="contained-modal-title-vcenter">Add User Request - {props.request.UserFullName}</Modal.Title>
        )}
      </Modal.Header>
      <Modal.Body>
        {props.request && (
          <div className="row justify-content-center">
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>User Full Name</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestFullName"
                  value={props.request.UserFullName}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>User Job Title</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestJobTitle"
                  value={props.request.JobTitle}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Company</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestCompany"
                  value={props.request.Company}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Office Location</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestOfficeLocation"
                  value={props.request.OfficeLocation}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Requested Date</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestRequestedDate"
                  value={Moment(props.request.CreatedDate).format("MMMM Do YYYY, h:mma")}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Requested By</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestRequestedBy"
                  value={props.request.RequestedBy}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Phone Number</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestEmailAccessDuration"
                  value={formatPhoneNumberString(
                    props.request.PhoneNumber1,
                    props.request.PhoneNumber1Ext,
                    props.request.PhoneNumber1Type
                  )}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Secondary Phone Number</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestEmailRecipient"
                  value={formatPhoneNumberString(
                    props.request.PhoneNumber2,
                    props.request.PhoneNumber2Ext,
                    props.request.PhoneNumber2Type
                  )}
                  disabled={true}
                />
              </div>
            </div>
            {props.request.OtherDistros && (
              <div className="row justify-content-center my-1">
                <div className="col-md">
                  <strong>Email Distros</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="addUserRequestRequestedTimeFrame"
                    value={ConvertEmptyToNA(props.request.OtherDistros.replace(", undefined", ""))}
                    disabled={true}
                  />
                </div>
              </div>
            )}

            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Effective Date</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestIsUnplanned"
                  value={Moment(props.request.EffectiveDate).format("MMMM Do YYYY, h:mma")}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Business Central Security Role</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestIsUnplanned"
                  value={ConvertEmptyToNA(props.request.BusinessCentralSecurityRole)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Who is being replaced?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestIsUnplanned"
                  value={ConvertEmptyToNA(props.request.ReplacingFullName)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Who should be notified?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={ConvertEmptyToNA(props.request.Notify)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Field Sales Access</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyFranchisee"
                  value={ConvertEmptyToNA(props.request.FieldSalesAccess)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Contract and Financial Details Access</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={ConvertEmptyToNA(props.request.ContractAndFinancialDetailsAccess)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Avalara?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestIsUnplanned"
                  value={formatBooleanAsString(props.request.Avalara)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Power BI?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyFranchisee"
                  value={formatBooleanAsString(props.request.PowerBi)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Jet Hub?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.JetHub)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Solver?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.Solver)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Acrobat Pro?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.AcrobatPro)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Max Agent?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestIsUnplanned"
                  value={formatBooleanAsString(props.request.MaxAgent)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Training Environments?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyFranchisee"
                  value={formatBooleanAsString(props.request.TrainingEnvironments)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>City Wide Social?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.CityWideSocial)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Desk Phone?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.DeskPhone)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Headset?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.Headset)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Zendesk Agent?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.ZendeskAgent)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>City Wide You Admin?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.CityWideYouAdmin)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              {props.mode === "incomplete" && (
                <>
                  <div className="col-lg">
                    <strong>Adobe Creative Cloud?</strong>
                    <input
                      type="text"
                      className={`text-input w-100`}
                      name="addUserRequestNotifyOther"
                      value={formatBooleanAsString(props.request.AdobeCreativeCloud)}
                      disabled={true}
                    />
                  </div>
                  <div className="col-lg">
                    <strong>Hub Staff?</strong>
                    <input
                      type="text"
                      className={`text-input w-100`}
                      name="addUserRequestNotifyOther"
                      value={formatBooleanAsString(props.request.HubStaff)}
                      disabled={true}
                    />
                  </div>
                </>
              )}
              <div className="col-lg">
                <strong>Monitors?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.Montiors)}
                  disabled={true}
                />
              </div>
            </div>
            {props.mode === "completed" && (
              <div className="row justify-content-center my-1">
                <div className="col-lg">
                  <strong>Completed Date</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="addUserRequestRequestedDate"
                    value={Moment(props.request.CompletedDate).format("MMMM Do YYYY, h:mma")}
                    disabled={true}
                  />
                </div>
                <div className="col-lg">
                  <strong>Completed By</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="addUserRequestRequestedBy"
                    value={props.request.CompletedBy}
                    disabled={true}
                  />
                </div>
              </div>
            )}
            <div className="row justify-content-center my-1">
              <div className="col-md">
                <strong>Who Do They Directly Report To?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="addUserRequestDirectReport"
                  value={props.request.DirectReport}
                  disabled={true}
                />
              </div>
            </div>

            <br />
            {props.mode === "incomplete" && request && (
              <>
                <div className="mt-1">
                  <div className="d-flex flex-row">
                    <div className="col-lg checklist-item">
                      <input
                        type="checkbox"
                        className={`details-modal-checkbox`}
                        name="addUserRequestIsFranchiseAccountingSetup"
                        checked={request.FranchiseAccounting}
                        onChange={() => onCheckboxClick("franAccount")}
                      />
                      <strong>Is Franchise Accounting Set Up?</strong>
                    </div>
                    <div className="col-lg checklist-item">
                      <input
                        type="checkbox"
                        className={`details-modal-checkbox`}
                        name="addUserRequestIsInTwoLogin"
                        checked={request.InTwoLogin}
                        onChange={() => onCheckboxClick("inTwo")}
                      />
                      <strong>Is In Two Login Created?</strong>
                    </div>
                    <div className="col-lg checklist-item">
                      <input
                        type="checkbox"
                        className={`details-modal-checkbox`}
                        name="addUserBc"
                        checked={request.Bc}
                        onChange={() => onCheckboxClick("bc")}
                      />
                      <strong>Is BC Setup Complete?</strong>
                    </div>
                  </div>
                  <div className="d-flex flex-row">
                    <div className="col-lg checklist-item">
                      <input
                        type="checkbox"
                        className={`details-modal-checkbox`}
                        name="addUserJetHub"
                        checked={request.JetHubCreate}
                        onChange={() => onCheckboxClick("jet")}
                      />
                      <strong>Is Jet Hub Account Creation Complete?</strong>
                    </div>
                    <div className="col-lg checklist-item">
                      <input
                        type="checkbox"
                        className={`details-modal-checkbox`}
                        name="addUserZendeskSetup"
                        checked={request.ZendeskSetup}
                        onChange={() => onCheckboxClick("zendesk")}
                      />
                      <strong>Is Zendesk Set Up Complete?</strong>
                    </div>
                    <div className="col-lg checklist-item">
                      <input
                        type="checkbox"
                        className={`details-modal-checkbox`}
                        name="addUserGroupManagement"
                        checked={request.GroupManagement}
                        onChange={() => onCheckboxClick("groupMan")}
                      />
                      <strong>Is Group Management Set Up?</strong>
                    </div>
                  </div>
                  <div className="d-flex flex-row">
                    <div className="col-lg checklist-item">
                      <input
                        type="checkbox"
                        className={`details-modal-checkbox`}
                        name="addUserExchangeLicense"
                        checked={request.ExchangeLicense}
                        onChange={() => onCheckboxClick("exchange")}
                      />
                      <strong>Is Exchange License Created?</strong>
                    </div>
                    <div className="col-lg checklist-item">
                      <input
                        type="checkbox"
                        className={`details-modal-checkbox`}
                        name="addUserO365"
                        checked={request.O365License}
                        onChange={() => onCheckboxClick("o365")}
                      />
                      <strong>Is Office 365 Setup Complete?</strong>
                    </div>
                    <div className="col-lg checklist-item">
                      <input
                        type="checkbox"
                        className={`details-modal-checkbox`}
                        name="addUserDistro"
                        checked={request.DistroSetup}
                        onChange={() => onCheckboxClick("distro")}
                      />
                      <strong>Is Distro Set Up Complete?</strong>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="row justify-content-left my-1">
              <div className="col-md-3 text-left" style={{ width: "100%" }}>
                <strong>Special Instructions:</strong>
                <textarea
                  className="text-input"
                  rows={7}
                  style={{ width: "100%" }}
                  disabled
                  value={props.request.SpecialInstructions}
                ></textarea>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      {props.mode === "incomplete" && (
        <Modal.Footer style={{ position: "sticky", bottom: 0, backgroundColor: "white" }}>
          <Button data-testid="delete-modal-no-button" variant="primary" onClick={() => onSave()}>
            Save
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default AddUserRequestDetailsModal;
